/**
 * Builds the `ml_lens` envelope for the Full Page Search `ui taskSuccess`
 * (`capability: fullPageSearchResult`) event.
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * Emits a single `total_connectors` metric whose value is the number of
 * products available to the search (i.e. `availableProducts.length`).
 *
 * This is a thin, surface-specific wrapper around the generic
 * {@link buildMlLensEnvelope}.
 */

import { buildMlLensEnvelope, type MlLensEnvelope } from './ml-lens-envelope';

export const FULL_PAGE_SEARCH_ML_LENS_NAMESPACE = 'rovo.full_search_page';

export const FULL_PAGE_SEARCH_ML_LENS_BASE_TAGS = {
	page: 'full_search_page',
	task: 'search_result',
} as const;

export const FULL_PAGE_SEARCH_TOTAL_CONNECTORS_METRIC_KEY = 'total_connectors';

/**
 * Build the `ml_lens` envelope for the Full Page Search `taskSuccess` event.
 *
 * @param totalConnectors Number of available products/connectors for the
 *                        search (typically `availableProducts.length`).
 * @param userId          Current user id; added to metric-set tags as
 *                        `user_id` when present, omitted when null/undefined.
 */
export const buildFullPageSearchMlLensEnvelope = (
	totalConnectors: number,
	userId?: string | null,
): MlLensEnvelope =>
	buildMlLensEnvelope({
		namespace: FULL_PAGE_SEARCH_ML_LENS_NAMESPACE,
		baseTags: { ...FULL_PAGE_SEARCH_ML_LENS_BASE_TAGS },
		userId,
		metrics: [
			{
				key: FULL_PAGE_SEARCH_TOTAL_CONNECTORS_METRIC_KEY,
				type: 'number',
				value: totalConnectors,
				tags: {},
			},
		],
	});
